module.exports = __webpack_public_path__ + "img/support-stats-Homepage.261aba2.png";